import React, { PropTypes, Component } from 'react'
import birthday from './services/services.js'
import moment from 'moment';
import ModalNotificacion from './components/Modal.jsx'
export class Global extends Component {
    constructor(props) {
        super(props);
        this.state = {
            personas: [],
            showModal: false,
        };
        this.fetchData = () => {
            birthday.birthday.getBirthdayNotifications()
                .then(response => {
                    if (!response.show) {
                        return;
                    }
                    this.setState({
                        showModal: true,
                        personas: response.personas
                    });
                })
                .catch(error => {
                    console.error(error);
                });
        };
    }
    componentDidMount() {
        const hoy = moment().format('YYYY-MM-DD');
        if (sessionStorage.getItem('cumpleanosVisto') === hoy) {
            return;
        }
        this.fetchData();
    }

    cerrarModal = () => {
        const hoy = moment().format('YYYY-MM-DD');
        birthday.birthday.markAsViewed()
            .catch(error => {
                console.error(error);
            })
            .then(() => {
                sessionStorage.setItem('cumpleanosVisto', hoy);
                this.setState({
                    showModal: false
                });
            });
    }

    render() {
        return (
            <ModalNotificacion
                showModal={this.state.showModal}
                cancelModal={this.cerrarModal}
                personas={this.state.personas}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/Notificacion/Global.jsx